export const getOrderedProsTabs = (tabsByType, prosTabsSequence) => {
  // Clone the arrays into queues so we can pull items off them one by one
  const queues = {
    sale: [...(tabsByType.sale || [])],
    category: [...(tabsByType.category || [])],
    brand: [...(tabsByType.brand || [])],
  };

  // Map over the sequence, pull the first available tab for that type,
  // and filter out undefined values if a queue runs out.
  return prosTabsSequence.map((type) => queues[type]?.shift()).filter(Boolean);
};
